<template>
	<div class="page-head">
		<div class="left"><slot name="left"></slot></div>
		<!-- <div class="center"><slot></slot></div> -->
		<div class="right"><slot name="right"></slot></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>

<style lang="less">
	.page-head {
		margin-bottom: 20px;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		width: 100%;
		.left {
			display: flex;
			width: 100%;
			.el-button {
				margin-right: 20px;
			}
		}
	}
</style>